/**
 * Reads the AIChatAgentConfig context. Throws if used outside its provider.
 *
 * Isolated read path for the AgentConfig slice (state + setters). Each slice context is
 * subscribed to directly — there is no merged value.
 */
import { useContext } from 'react';
import { AIChatAgentConfigContext } from './AIChatAgentConfigProvider';
import type { AIChatAgentConfigValue } from './AIChatAgentConfigProvider';

export function useAIChatAgentConfig(): AIChatAgentConfigValue {
  const context = useContext(AIChatAgentConfigContext);
  if (!context) {
    throw new Error('useAIChatAgentConfig must be used within a AIChatAgentConfigProvider');
  }
  return context;
}
